import React from 'react';
import { Box, styled } from '@landr/maestro';
import { Field } from 'formik';

const CustomLabel = styled.label`
    position: relative;
    margin: 0.25em;
    min-height: 20px;
    cursor: pointer;
    height: 20px;

    input {
        visibility: hidden;
        position: absolute;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
    }
    input::after {
        border: 1px solid #fff;
        content: '';
        visibility: visible;
        position: absolute;
        -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
        left: 0px;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        pointer-events: none;
        margin-top: 12px;
    }

    input:checked::after {
        background: #fff;
    }
`;

type RadioProps = {
    name: string;
    value: string;
    label: string;
};

const Radio = ({ name, value, label }: RadioProps) => {
    return (
        <CustomLabel>
            <Field type="radio" name={name} value={value} />
            <Box ml="24px">{label}</Box>
        </CustomLabel>
    );
};

export default Radio;
